import type {AgentInfo} from '@github-ui/agent-sessions-types/agent-identity'

/**
 * Hardcoded agent info for agents the API does not describe.
 *
 * Kept free of component imports on purpose: the agent profile registry above
 * this package pulls in trailing visuals and, through them, the hooks that need
 * agent info in the first place.
 */
export const AGENT_INFO_REGISTRY: Record<string, AgentInfo> = {
  'copilot-developer-cli': {
    display_name: 'Copilot CLI',
    slug: 'copilot-developer-cli',
    avatar_url: '',
    doc_url: '',
  },
  'vscode-chat': {
    display_name: 'Copilot in VS Code',
    slug: 'vscode-chat',
    avatar_url: '',
    doc_url: '',
  },
  'jetbrains-chat': {
    display_name: 'Copilot in JetBrains',
    slug: 'jetbrains-chat',
    avatar_url: '',
    doc_url: '',
  },
}

/**
 * Look up hardcoded agent info by slug. Returns null if the slug is unknown.
 */
export function getAgentInfoBySlug(slug?: string): AgentInfo | null {
  if (slug && AGENT_INFO_REGISTRY[slug]) {
    return AGENT_INFO_REGISTRY[slug]
  }
  return null
}
